<template>
  <div
    id="dashboardPage"
    class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div v-if="send_store" class="card-body">
            <form action="" @submit="requestCalculation">
              <div class="flex">
                <div>
                  <label>Склад отправитель</label>
                  <select v-model="send_store" name="send_store" class="form-control">
                    <option
                      v-for="(store, index) in send_store_list" :key="index"
                      :value="store.id">{{ store.name }}</option>
                  </select>
                </div>
                <div>
                  <label>Склад получатель</label>
                  <select v-model="receive_store" name="receive_store" class="form-control">
                    <option
                      v-for="(store, index) in receive_store_list" :key="index"
                      :value="store.id">{{ store.name }}</option>
                  </select>
                </div>
                <div style="position: relative;min-width: 200px;">
                  <button style="position: absolute;bottom: 0" class="btn btn-info" type="submit">Показать бронь</button>
                  <div class="clearfix"/>
                </div>
                <div style="position: relative;min-width: 200px;">
                  <button style="position: absolute;bottom: 0" class="btn btn-info" type="submit" @click="getStorageRequest">Показать запас</button>
                  <div class="clearfix"/>
                </div>
                <div style="position: relative;min-width: 200px;">
                  <button style="position: absolute;bottom: 0" class="btn btn-info" type="button" @click="getAllPreStore">Просчитать запас</button>
                  <div class="clearfix"/>
                </div>
                <div style="position: relative;min-width: 200px;">
                  <button style="position: absolute;bottom: 0" class="btn btn-info" type="button" @click="getClearedFigures">Автосписок</button>
                  <div class="clearfix"/>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="loading" :color="color" style="text-align: center"/>

    <div v-if="storage_calculation">
      <div class="card">
        <div class="card-body">
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Наличие на отправителе</th>
              <th class="wd-200">Брони на дочерних</th>
              <th class="wd-100">Обновл. наличие на отправителе</th>
              <th class="wd-100">Наличие на получателе</th>
              <th class="wd-100">Запрос получателя</th>
              <th class="wd-100">Окр</th>
              <th class="wd-100">Чистый запрос</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(storage_calculation.prep_names)" :key="index">
                <td>{{ index+1 }}</td><td>{{ prep.id }}</td><td>{{ prep.name }}</td>
                <td>{{ storage_calculation.in_send_store[prep.id] }}</td>
                <td>
                  <div v-for="(qnty, storeId, index2) in storage_calculation.reserved_qnty[prep.id]">
                    {{ storage_calculation.stores_names[storeId] }} => {{ qnty }}
                  </div>
                </td>
                <td>
                  {{ storage_calculation.updated_send_store[prep.id] }}
                </td>
                <td>{{ storage_calculation.in_receive_store[prep.id] }}</td>
                <td>{{ storage_calculation.storage_request[prep.id] }}</td>
                <td>{{ getRoundedQuantity(storage_calculation.storage_request[prep.id]) }}</td>
                <td>{{ storage_calculation.in_receive_store[prep.id] - getRoundedQuantity(storage_calculation.storage_request[prep.id]) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="request">
      <h4>Общая картинка</h4>
      <div class="card">
        <div class="card-body">
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Наличие на отправителе</th>
              <th class="wd-100">Наличие на получателе</th>
              <th class="wd-100">Запрос получателя</th>
              <th class="wd-200">Запрос дочерних</th>
              <th class="wd-100">Остаток получателя</th>
              <th class="wd-100">Остаток отправителя</th>
            </thead>
            <tbody>
              <!--                    <tr v-for="(prep, prepId, index) in data.requested_preps" :key="index">-->
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names)" :key="index">
                <td>{{ index+1 }}</td><td>{{ prep.id }}</td><td>{{ prep.name }}</td>
                <td>
                  {{ request.in_send_store[prep.id] }}
                </td>
                <td>
                  {{ request.in_receive_store[prep.id] }}
                </td>
                <td>
                  <span v-if="request.requested_preps[prep.id]">{{ request.requested_preps[prep.id].total }}</span>
                </td>
                <td>
                  <div v-for="(storeId, index) in request.dother_stores" :key="index">
                    <span v-if="request.store[storeId][prep.id]">{{ request.store_names[storeId] }} => {{ request.store[storeId][prep.id]*(-1) }}</span>
                  </div>
                </td>
                <td>
                  {{ (request.in_receive_store[prep.id] ? request.in_receive_store[prep.id] : 0) - getRequestedQuantity(request, prep.id) }}
                </td>
                <td>
                  <!--                  {{(request.in_send_store[prep.id] ? request.in_send_store[prep.id] : 0) + (request.store[request.store_id][prep.id] ? request.store[request.store_id][prep.id] : 0) + getAllRequestsByPrep(request, prep.id)}}-->
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h4>Закрывает отправитель</h4>
      <div class="card">
        <div class="card-body">
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.sender_prep_names.close)" :key="index">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.sender_order.close[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h4>Не закрывает отправитель</h4>
      <div class="card">
        <div class="card-body">
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.sender_prep_names.no_close)" :key="index">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.sender_order.no_close[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <pulse-loader :loading="loading_long" :color="color" style="text-align: center"/>

    <div v-if="reserve_total">
      <div class="card">
        <div class="card-body">
          <h5>Брони</h5>
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Для закрытия брони</th>
              <th class="wd-100">На отправителе</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(reserve_total.prep_names)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ reserve_total.request[prep.id] }}</td>
                <td>{{ reserve_total.send_store[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
          <h5>Закрываем бронь</h5>
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(reserve_total.prep_names ,reserve_total.reserve_request_closing.close)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ reserve_total.reserve_request_closing.close[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
          <h5>НЕ закрываем бронь</h5>
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(reserve_total.prep_names ,reserve_total.reserve_request_closing.no)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ reserve_total.reserve_request_closing.no[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5>Запас</h5>
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <!--            <th class="wd-100">Бронь</th>-->
              <th class="wd-100">Запрос на запас</th>
              <th class="wd-100">На получателе</th>
              <th class="wd-100">На Отправителе</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(reserve_total.store_preps_name)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ getRoundedQuantity(reserve_total.requested_store_quantities[prep.id]) }}</td>
                <td>{{ reserve_total.store_preps_for_store[prep.id] }}</td>
                <td>{{ reserve_total.store_preps_for_supply[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
          <h5>Закрываем запас</h5>
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(reserve_total.closing_names ,reserve_total.store_request_closing.close)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ reserve_total.store_request_closing.close[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
          <h5>НЕ закрываем запас</h5>
          <table class="table table-hover">
            <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
            </thead>
            <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(reserve_total.closing_names ,reserve_total.store_request_closing.no)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ reserve_total.store_request_closing.no[prep.id] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="store_request">
      <div v-for="(name, id, index) in store_request.stores_names" :key="index">
        <div v-if="store_request.requested_quantities[id]" class="card">
          <div class="card-body">
            <button class="btn btn-default" @click="store_request.requested_quantities[id].isShow = !store_request.requested_quantities[id].isShow">{{ name }}</button> id:{{ id }}
            <div v-show="store_request.requested_quantities[id].isShow">
              <table class="table table-hover">
                <thead>
                  <th class="wd-40"/>
                  <th class="wd-200"/>
                  <th>Препарат</th>
                  <th class="wd-100">Необходимо</th>
                  <th class="wd-100">Наличии</th>
                  <th class="wd-100">Бронь</th>
                  <th class="wd-100">Остаток</th>
                  <th class="wd-100">Окр</th>
                  <th class="wd-100">Запрос</th>

                </thead>
                <tbody :id="['storage_'+id]">
                  <tr v-for="(prep, index) in orderedPrepNames(store_request.prep_names, store_request.requested_quantities[id])" v-if="store_request.requested_quantities[id][prep.id]" :key="index" >
                    <td>{{ index+1 }}</td>
                    <td>{{ prep.id }}</td>
                    <td>{{ prep.name }}</td>
                    <td>{{ store_request.requested_quantities[id][prep.id] }}</td>
                    <td>{{ store_request.actual_storage[id][prep.id] }}</td>
                    <td>
                      <div v-if="store_request.preps_in_reserve[id][prep.id] && store_request.preps_in_reserve[id][prep.id][id]">
                        <div v-for="(qnty, orderId) in store_request.preps_in_reserve[id][prep.id][id].orders">
                          {{ orderId }} => {{ qnty }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div v-if="store_request.preps_in_reserve[id][prep.id] && store_request.preps_in_reserve[id][prep.id][id]">
                        {{ store_request.actual_storage[id][prep.id] - store_request.preps_in_reserve[id][prep.id].total }}
                      </div>
                      <div v-else>{{ store_request.actual_storage[id][prep.id] }}</div>
                    </td>
                    <td>
                      {{ getRoundedQuantity(store_request.requested_quantities[id][prep.id]) }}
                    </td>
                    <td>
                      {{ getDifference(store_request.requested_quantities[id][prep.id], store_request.actual_storage[id][prep.id], store_request.preps_in_reserve[id][prep.id]) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <tabs class="tabs-default hidden">
      <tab name="Общая бронь">
        <div v-if="all_data" style="padding:0 20px">
          <div v-for="(data, index) in tab_1_data" :key="index" class="card">
            <div class="card-body">
              <button class="btn btn-default" @click="data.isShow = !data.isShow">{{ data.store.name }}</button> id:{{ data.store.id }}
              <div v-show="data.isShow">
                <table class="table table-hover">
                  <thead>
                    <th class="wd-40"/>
                    <th class="wd-200"/>
                    <th>Препарат</th>
                    <th class="wd-100">Бронь</th>
                    <th class="wd-200">Заявки</th>
                    <th class="wd-200">Склад по факту</th>
                    <th class="wd-200">Транзит</th>
                    <th class="wd-200">Склад - транзит</th>
                    <th class="wd-200">Склад - Бронь</th>
                    <th class="wd-100">Новая бронь</th>
                  </thead>
                  <tbody>
                    <!--                    <tr v-for="(prep, prepId, index) in data.requested_preps" :key="index">-->
                    <tr v-for="(prep, index) in orderedPrepNames(data.prep_names)" :key="index">
                      <td>{{ index+1 }}</td><td>{{ prep.id }}</td><td>{{ prep.name }}</td>
                      <td>{{ data.requested_preps[prep.id].ttl }}</td>
                      <td>
                        <span v-for="(qnty, order, index2) in data.requested_preps[prep.id].orders" :key="index2"><br v-if="index2 != 0">{{ order }} => {{ qnty }}</span>
                      </td>
                      <td>
                        <span v-for="(qnty, store, index3) in data.actual_store[prep.id]" :key="index3">
                          <br v-if="index3 != 0">
                          {{ data.store_names[store] }} => {{ qnty }}
                        </span>
                      </td>
                      <td>
                        <div v-if="data.preps_in_transit.in[prep.id]">
                          <span>Поступление</span>
                          <div v-for="(preps, storeId) in data.preps_in_transit.in[prep.id]">
                            <span>{{ data.store_names[storeId] }} => <b>{{ preps.total }}</b></span>
                            <span v-for="(invoices, index5) in preps">
                              <br><span v-if="index5 != 'total'">{{ invoices.invoice }} => {{ invoices.qnty }}</span>
                            </span>
                          </div>
                        </div>
                        <div v-if="data.preps_in_transit.out[prep.id]">
                          <span>Перемещение</span>
                          <div v-for="(preps, storeId) in data.preps_in_transit.out[prep.id]">
                            <span>{{ data.store_names[storeId] }} => <b>{{ preps.total }}</b></span>
                            <span v-for="(invoices, index5) in preps">
                              <br><span v-if="index5 != 'total'">{{ invoices.invoice }} => {{ invoices.qnty }}</span>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span v-for="(qnty, storeId, index6) in data.actual_store_wtransit[prep.id]" :key="index6">
                          <br v-if="index6 != 0">
                          {{ data.store_names[storeId] }} => {{ qnty }}
                        </span>
                      </td>
                      <td>
                        <span v-for="(qnty, store, index4) in data.updated_store[prep.id]" :key="index4">
                          <br v-if="index4 != 0">
                          {{ data.store_names[store] }} => {{ qnty }}
                        </span>
                      </td>
                      <td>{{ data.updated_request[prep.id].ttl }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Запросы">
        <div v-if="all_data" style="padding:0 20px">
          <div v-for="(data, index) in tab_1_data" :key="index" class="card">
            <div class="card-body">
              <button class="btn btn-default" @click="data.isShow = !data.isShow">{{ data.store.name }}</button> id:{{ data.store.id }}
              <div v-show="data.isShow">
                <table class="table table-hover">
                  <thead>
                    <th class="wd-40"/>
                    <th class="wd-200"/>
                    <th>Препарат</th>
                    <th class="wd-100">Бронь</th>
                  </thead>
                  <tbody>
                    <tr v-for="(prep, index) in orderedPrepNamesWithRequest(data.prep_names, data.updated_request)" :key="index">
                      <td>{{ index+1 }}</td><td>{{ prep.id }}</td><td>{{ prep.name }}</td><td>{{ data.updated_request[prep.id].ttl }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </tab>

      <tab name="tab3">
        <!-- Your content -->
      </tab>
    </tabs>

  </div>
</template>

<style scoped>
  .clearfix{
    clear: both;
  }
  .flex{
    display: flex;
    justify-content: space-around;
  }
  table td{
    padding: 2px;
  }
  table .city_name{
    background-color: lightblue;
    color: black;
  }
  .wd-40{
    width: 40px;
  }
  .wd-100{
    white-space: normal;
    width: 110px;
  }
  .wd-200{
    width: 115px;
  }
  .hidden{
    display: none;
  }
</style>

<script>

import api from '@/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {

  components: {
    PulseLoader
  },
  data () {
    return {
      orders_w_reserve: null,
      urgent_request: null,
      regular_request: null,
      orders_w_reserve_count: null,
      stores: null,
      send_store_list: null,
      receive_store_list_data: null,
      receive_store: null,
      send_store: null,
      loading: false,
      loading_long: false,
      loading_tables: true,
      color: '#5BBFDE',
      requests: null,
      request: null,
      request_2: null,
      all_requests: null,
      preps_names: null,
      preps_in_store_after: null,
      in_send_store: null,
      ttl_requested: null,
      listStores: null,
      all_data: [],
      tab_1_data: [],
      preStore: null,
      store_request: null,
      storage_calculation: null,
      reserve_total: null
      // receive_store_list: null
    }
  },
  computed: {
    receive_store_list () {
      if (this.receive_store_list_data) {
        this.receive_store = this.receive_store_list_data[this.send_store][0].id
        return this.receive_store_list_data[this.send_store]
      }
    }
  },

  mounted () {
    // this.getContent()
    // this.getAllRequests()
    this.getStores()
  },
  methods: {
    getStorageRequest: async function (e) {
      this.loading = true
      this.request = null
      this.storage_calculation = null
      e.preventDefault()
      try {
        const {data} = await api.store('/getStorageData', {
          send_store: this.send_store,
          receive_store: this.receive_store
        })
        this.storage_calculation = {
          in_receive_store: data.in_receive_store,
          prep_names: data.prep_names,
          storage_request: data.storage_request,
          updated_send_store: data.updated_send_store,
          in_send_store: data.in_send_store,
          reserved_qnty: data.reserved_qnty,
          stores_names: data.stores_names
        }

        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    getDifference: function (requested_qnty, in_storage, in_reserve) {
      let remain = in_storage - (in_reserve ? in_reserve.total : 0)
      let result = this.getRoundedQuantity(requested_qnty) - (remain < 0 ? 0 : remain)
      return result < 0 ? 0 : Math.round(result)
    },
    getRoundedQuantity: function (num) {
      if (num < 2) {
        return Math.ceil(num)
      } else {
        return Math.round(num)
      }
    },
    getAllRequestsByPrep: function (request, prepId) {
      let sum = 0
      request.dother_stores.forEach(function (storeId) {
        if (request.store[storeId][prepId]) {
          sum += request.store[storeId][prepId]
        }
      })
      return sum
    },
    orderedPrepNames: function (preps, request = false) {
      let sorted = _.orderBy(preps, 'name')
      if (request) {
        sorted = sorted.filter(x => request[x.id])
      }
      return sorted
      // return _.orderBy(preps, 'name').filter(x => )
    },
    getRequestedQuantity: function (request, prepId) {
      let ttl_request = (request.requested_preps[prepId] ? request.requested_preps[prepId].total : 0) + (this.getAllRequestsByPrep(request, prepId) * (-1))
      return ttl_request
    },
    orderedPrepNamesWithRequest: function (preps, request) {
      return this.orderedPrepNames(preps).filter(x => request[x.id].ttl != 0)
    },
    async getContent () {
      const {data} = await api.index('/autolists')

      Object.keys(data.urgent_request).map((key, i) => data.urgent_request[key].isShow = false)
      Object.keys(data.regular_request).map((key, i) => data.regular_request[key].isShow = false)

      this.orders_w_reserve = data.orders_w_reserve
      this.urgent_request = data.urgent_request
      this.regular_request = data.regular_request
      this.orders_w_reserve_count = data.orders_w_reserve.length
      this.stores = data.stores_in_cities
      this.loading_tables = false
    },
    getClearedFigures: async function (e) {
      this.loading_long = true
      e.preventDefault()
      try {
        const {data} = await api.store('/buildAutolist', {
          send_store: this.send_store,
          receive_store: this.receive_store
        })

        this.reserve_total = {
          request: data.reserve_request,
          prep_names: data.prep_names,
          pre_request: data.pre_request,
          send_store: data.send_store,
          requested_store_quantities: data.requested_store_quantities,
          store_preps_name: data.store_preps_name,
          store_preps_for_store: data.store_preps_for_store,
          store_preps_for_supply: data.store_preps_for_supply,
          reserve_request_closing: data.reserve_request_closing,
          store_request_closing: data.store_request_closing,
          closing_names: data.closing_names
          // all_reseve_request: data.all_reseve_request,
        }
        this.loading_long = false
      } catch (e) {
        console.log(e)
      }
    },
    showReserveRows (event) {
      // console.log(event)
      // console.log(event.closest('tbody'))
      // event.closest('tbody').find('.toggle_row').toggle('active')
    },
    async getStores () {
      const {data} = await api.index('/getStores')
      this.send_store_list = data.stores.send
      this.send_store = this.send_store_list[Object.keys(this.send_store_list)[0]].id
      this.receive_store_list_data = data.stores.receive
    },
    requestCalculation: async function (e) {
      this.loading = true
      this.request = null
      this.storage_calculation = null
      e.preventDefault()
      try {
        const {data} = await api.store('/getTransitData', {
          send_store: this.send_store,
          receive_store: this.receive_store
        })

        this.request = {
          store: data.store,
          store_names: data.store_names,
          prep_names: data.prep_names,
          dother_stores: data.dother_stores,
          store_id: data.store_id,
          in_send_store: data.in_send_store,
          in_receive_store: data.in_receive_store,
          requested_preps: data.requested_preps,
          sender_prep_names: data.sender_prep_names,
          sender_order: data.sender_order
        }
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    async getAllPreStore () {
      this.loading_long = true
      this.store_request = null
      const {data} = await api.store('/getAllPreStore')
      this.store_request = {
        requested_quantities: data.requested_quantities,
        prep_names: data.prep_names,
        stores_names: data.stores_names,
        actual_storage: data.actual_storage,
        preps_in_reserve: data.preps_in_reserve
      }
      this.loading_long = false
    },
    getAllRequests: function () {
      this.loading_long = true
      this.all_data = []
      this.tab_1_data = []
      this.all_requests = null
      this.listStores = {
        3: 'Москва',
        4: 'Почтовый',
        10: 'НЗвБк-СПБ (3А-ii)',
        11: 'НЗвБк-ЕКБ (3А-ii)',
        12: 'НЗвБк-СМР (3А-ii)',
        13: 'НЗвБк-ЧЛБ (3А-ii)',
        14: 'НЗвБк-НВС (3А-ii)',
        15: 'НЗвБк-КРС (3А-ii)',
        16: 'НЗвБк-ТМН (3А-ii)',
        17: 'НЗвБк-ИРК (3А-ii)',
        18: 'НЗвБк-СРТ (3А-ii)'
      }
      for (var id in this.listStores) {
        this.getRequests(id)
      }
      this.all_requests = this.all_data
      // console.log(this.all_data)

      // listStores.forEach(function (value, key) {
      //   this.getRequests(key)
      // })
    },
    async getRequests (key) {
      this.loading_long = true
      const {data} = await api.store('/getTransitData', {send_store: 2, receive_store: key})
      this.all_data.push({
        data: data.requests_arr,
        store_id: key,
        in_send_store: data.in_send_store,
        orders_of_preps: data.orders_of_preps,
        related_stores: data.related_stores,
        actual_store_start: data.actual_store_start,
        ttl_requests_by_store: data.ttl_requests_by_store,
        isShow: false
      })
      this.tab_1_data.push({
        store: data.tab_1_data.store,
        requested_preps: data.tab_1_data.requested_preps,
        prep_names: data.tab_1_data.prep_names,
        actual_store: data.tab_1_data.actual_store,
        store_names: data.tab_1_data.store_names,
        updated_store: data.tab_1_data.updated_store,
        updated_request: data.tab_1_data.updated_request,
        actual_store_wtransit: data.tab_1_data.actual_store_wtransit,
        preps_in_transit: data.tab_1_data.preps_in_transit,
        isShow: false
      })
      this.loading_long = false
    }
  }
}

</script>
